
import { Notification } from 'types/Notification'

export interface NotificationStore {
  open: boolean,
  settingsOpen: boolean,
  notifications: Notification[],
}

export enum NotificationActions {
  OPEN_NOTIFICATION_MODAL = 'OPEN_NOTIFICATION_MODAL',
  CLOSE_NOTIFICATION_MODAL = 'CLOSE_NOTIFICATION_MODAL',
  TOGGLE_NOTIFICATION_SETTINGS = 'TOGGLE_NOTIFICATION_SETTINGS',
  SET_NOTIFICATIONS = 'SET_NOTIFICATIONS',
}

export const NotificationAction = {
  setNotifications: (notifications: Notification[]) => ({ type: NotificationActions.SET_NOTIFICATIONS, payload: notifications }),
}

const createDefaultState = (): NotificationStore => ({
  open: false,
  settingsOpen: false,
  notifications: [],
})


const createNotificationReducer = () => (state: NotificationStore = createDefaultState(), action: any): NotificationStore => {
  switch (action.type) {
    case NotificationActions.OPEN_NOTIFICATION_MODAL: {
      return {
        ...state,
        open: true,
      }
    }
    case NotificationActions.CLOSE_NOTIFICATION_MODAL: {
      return {
        ...state,
        open: false,
        settingsOpen: false,
      }
    }
    case NotificationActions.TOGGLE_NOTIFICATION_SETTINGS: {
      return {
        ...state,
        settingsOpen: !state.settingsOpen,
      }
    }
    case NotificationActions.SET_NOTIFICATIONS: {
      return {
        ...state,
        notifications: action.payload,
      }
    }
    default: {
      return state
    }
  }
}


export default createNotificationReducer
